import { get } from "../../index";
import ProposalsRoutes from "./Proposals.routes";

const ProposalsServices = {
  getAllProposals: async (page, limit, adId, userId, roles, status, from, to) => {
    const result = await get(ProposalsRoutes.getAllProposals +
      `?page=${page}&limit=${limit}&ad_id=${adId}&user_id=${userId}&roles=${roles}&status=${status}&created_at_from=${from}&created_at_to=${to}`
    );
    return result;
  }
}

export default ProposalsServices;